import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue';
import App from './App.vue';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';

import './assets/fonts.css';

import router from './router';
import i18n from './i18n';

Vue.use(BootstrapVue);

// eslint-disable-next-line no-new
new Vue({
  router,
  i18n,
  el: '#app',
  components: { App },
  template: '<App/>',
});



// WEBPACK FOOTER //
// ./src/main.js